import React from 'react'
import { createPortal } from 'react-dom'
import { Dropdown } from 'react-bootstrap'
import type { DropdownMenuProps } from 'react-bootstrap'
import { getWindow } from '@ztechapps/common.utils'

export type PortalDropdownMenuProps = Omit<DropdownMenuProps, 'as'>

/**
 * A react-bootstrap `Dropdown.Menu` portalled to `document.body`, for a `Dropdown` whose host clips or restyles an
 * inline menu (a scrolling pane, the TinyMCE `.tox` header). Place it as a child of `Dropdown`; it keeps the
 * Dropdown's open/close state through context. Nothing renders until the body exists, hence the ternary and not a ShowIf.
 */
export const PortalDropdownMenu = (props: PortalDropdownMenuProps) => {
  const portalTarget = getWindow()?.document.body

  return portalTarget ? createPortal(<Dropdown.Menu {...props} />, portalTarget) : null
}
